import { Component, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbModal, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { ExtraExpenseService } from 'src/app/services/extra-expense.service';
import { ExtraExpense } from 'src/app/models/extra-expense';
import { ArticleService } from 'src/app/services/article.service';
import { ExpenseService } from 'src/app/services/expense.service';
import { Article } from 'src/app/models/article';
import { ExpenseType } from 'src/app/models/expense-type';
import { AuthService } from 'src/app/services/auth.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { Unity } from 'src/app/models/unity';
import { UnityService } from 'src/app/services/unity.service';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-extra-expense',
  templateUrl: './extra-expense.component.html',
  styleUrls: ['./extra-expense.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}],
})
export class ExtraExpenseComponent implements OnInit {

  date1:Date = new Date();
  date2:Date = new Date();
  expenses:ExtraExpense[] = [];
  expenseTypes:ExpenseType[] = [];
  //expenseType:ExpenseType;
  articles:Article[] = [];
  //article:Article;
  expense:ExtraExpense = new ExtraExpense();
  loading:boolean = false;
  unities:Unity[] = [];
  expand:boolean = false;

  public actEditExtra:boolean = true;
  public actAddExtra:boolean = true;
  public actDeleteExtra:boolean = true;

  constructor(private extraServ:ExtraExpenseService, private artServ:ArticleService, private expServ:ExpenseService, private authService:AuthService, private modalService: NgbModal, private utl:UtilitiesService, private unitySer:UnityService, private toastr: ToastrManager) { 
    this.date1.setDate(this.date1.getDate() - 6);
  }

  ngOnInit() {
    this.expServ.getExpenseTypes().then(types => {
      this.expenseTypes = types.filter(t => t.type == 'Variables' || t.type == 'Fijos');
      this.expense.expense_type_id = this.expenseTypes[0].id;
    });
    this.artServ.getArticles().then(articles => {
      this.articles = articles.filter(article => article.expense_type.type == 'Fijos' || article.expense_type.type == 'Variables');
      this.expense.article_id = this.articles[0].id;

      this.changeArticle();
    });
    this.unitySer.getUnities().then(unities => this.unities = unities);

    this.search();

    this.actEditExtra = this.authService.can("update-extra-expense");
    this.actDeleteExtra = this.authService.can("destroy-extra-expense");
    this.actAddExtra = this.authService.can("store-extra-expense");
  }

  search() {
    this.loading = true;
    this.extraServ.getExtraExpenses(this.date1, this.date2).then(extra => {
      this.expenses = extra;
      this.loading = false;
    });
  }

  changeArticle() {
    let art = this.articles.find(a => a.id == this.expense.article_id);

    this.expense.expense_type_id = art.expense_type_id;
  }

  select(modal?, exp?:ExtraExpense) {
    if(exp) {
      this.expense = exp;
    } else {
      this.expense = new ExtraExpense();
      this.expense.expense_type_id = this.expenseTypes[0].id;
      this.expense.article_id = this.articles[0].id;
      this.expense.unity_id = null;

      this.changeArticle();
    }

    if(modal) {
      this.modalService.open(modal, { size: 'lg' });
    }
  }

  storeExtraExpense(event) {
    event.preventDefault();

    this.loading = true;
    this.extraServ.postExtraExpense(this.expense).then(result => {
      this.toastr.successToastr("Creado Correctamente con NO: " + result.id);
      result.active = true;
      this.expenses.push(Object.assign({}, result));
      this.loading = false;
    }).catch(e => {
      this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true });
      this.loading = false;
    });
  }

  updateExtraExpense(event) {
    event.preventDefault();

    this.loading = true;
    this.extraServ.putExtraExpense(this.expense).then(result => {
      this.toastr.successToastr("Actualizado Correctamente");
      let res = this.expenses.find(exp => exp.id == result.id);
      res = result;
      this.loading = false;
    }).catch(e => {
      this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true });
      this.loading = false;
    });
  }

  deleteExtraExpense() {
    this.loading = true;
    this.extraServ.deleteExtraExpense(this.expense).then(result => {
      this.toastr.successToastr("Eliminado Correctamente");
      this.expense.active = false;
      this.loading = false;
    }).catch(e => {
      this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true });
      this.loading = false;
    });
  }

}
